import type { ComputedRef, Ref } from 'vue'
import type { ITabProps } from 'components/tabs/types'

export const DEFAULT_CATEGORY_FILTER = "all"

export type CategoryFilterFn<T> = (items: T[], category: string) => T[]

export type SearchFilterFn<T> = (items: T[], query: string) => T[]

export type UseSearchFilters<T = any> = {
  selectedCategory: ComputedRef<string>
  queryString: ComputedRef<string>
  filteredItems: ComputedRef<T[]>
  showEmptyState: ComputedRef<boolean>
  
  selectCategory: (category: string) => void
  setQueryString: (query: string) => void
  reset: () => void
}

export type UseSearchFiltersProps<T = any> = {
  items: ComputedRef<T[]> | Ref<T[]> | T[]
  
  categoryKeywords?: Record<string, string[]>
  categoryTypeField?: string
  
  categoryFilterFn?: CategoryFilterFn<T>
  searchFilterFn?: SearchFilterFn<T>
  
  initialCategory?: string
}

export type IResponsiveSearchFiltersProps<T = any> = {
  filters: UseSearchFilters<T>
  tabs: ITabProps[]
  options?: {
    searchPlaceholder?: string
  }
}

